import { useMemo } from 'react';
import { useTravelPlacesPricingAndBookingDetailsFragment } from '@shared/hooks/useTravelPlacesPricingAndBookingDetails';
import { useTravelPlacesPriceComparisonFragment } from '@shared/hooks/useTravelPlacesPriceComparison';
import { useMinimumPercentageOffToDisplay } from '@shared/hooks/useMinimumPercentageOffToDisplay';
import { getPercentageOff } from '@shared/utils/accommodationPrice';
import { AccommodationCombined } from '../../../Accommodations/Accommodation.types';

export const useJoyPlacePricingV2PriceInfo = (accommodation: AccommodationCombined) => {
  const { minimumPercentageOffToDisplayValue, loadingMinimumPercentageOffToDisplay } = useMinimumPercentageOffToDisplay();

  const { price, loading: isTravelPlacesPricingAndBookingLoading, data } = useTravelPlacesPricingAndBookingDetailsFragment(accommodation.id, 'accommodationPlace');

  const priceData = data?.pricingInfo?.nightlyBaseRate;
  const priceMinorUnits = priceData?.valueInMinorUnits;
  const priceMinorUnitsDigits = priceData?.digits;

  const { rates, loading: isPriceComparisonLoading } = useTravelPlacesPriceComparisonFragment(accommodation.joyPlaceId!, !accommodation.joyPlaceId);

  const highestPriceFromRates = useMemo(() => [...rates].sort((a, b) => b.priceInMinorUnits - a.priceInMinorUnits)[0], [rates]);

  const percentageOff = useMemo(
    () =>
      getPercentageOff(minimumPercentageOffToDisplayValue, priceMinorUnits, highestPriceFromRates?.priceInMinorUnits, priceMinorUnitsDigits, highestPriceFromRates?.priceDigits),
    [highestPriceFromRates?.priceDigits, highestPriceFromRates?.priceInMinorUnits, minimumPercentageOffToDisplayValue, priceMinorUnits, priceMinorUnitsDigits]
  );

  const loading = loadingMinimumPercentageOffToDisplay || isTravelPlacesPricingAndBookingLoading || isPriceComparisonLoading;

  return { rates, price, percentageOff, loading };
};
